import { render, staticRenderFns } from "./TeamItem.vue?vue&type=template&id=5d996b3e&"
import script from "./TeamItem.vue?vue&type=script&lang=js&"
export * from "./TeamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports